module.exports = __webpack_public_path__ + "static/media/quotes.2d068de3.svg";